import { classNames } from 'libs/react';
import { React } from 'libs/react';
import './QuoteNotes.scss';
function hasClientNotes(notes) {
    return Boolean(notes === null || notes === void 0 ? void 0 : notes.replace(/<[^>]+>/g, '').trim());
}
/**
 * @component QuoteNotes
 * @since 1.0.0
 */
export function QuoteNotes(props) {
    var _a;
    const { data } = props;
    if (!hasClientNotes(data.notes)) {
        return null;
    }
    const className = classNames('quote-section', 'quote-notes', props.className);
    return (React.createElement("div", { id: "notes", className: className },
        React.createElement("div", { className: "quote-notes-heading" }, t('Notes')),
        React.createElement("div", { className: "quote-notes-content" },
            React.createElement("div", { className: "quote-notes-value", dangerouslySetInnerHTML: { __html: (_a = data.notes) !== null && _a !== void 0 ? _a : '' } }))));
}
